import eightAxios from "configs/axiosConfig";
import React, { useEffect, useState } from "react";
import { useNotifyContext } from "@Components/Notify";

import Form from "@Components/Form";
import { PUSHNOTIFICATION_SETTINGS_URL } from "configs/constants";
import LoadingIcon from "@Components/LoadingIcon/LoadingIcon";
import { FormLineBreak } from "../../../utils";
import { useTranslation } from "react-i18next";

const initialValues = {
  kelantan_clock_in: "",
  pahang_clock_in: "",
  perak_clock_in: "",
  johor_clock_in: "",
  terengganu_clock_in: "",
  sabah_clock_in: "",
  kedah_clock_in: "",
  negeri_sembilan_clock_in: "",
  sarawak_clock_in: "",
  kelantan_clock_out: "",
  pahang_clock_out: "",
  perak_clock_out: "",
  johor_clock_out: "",
  terengganu_clock_out: "",
  sabah_clock_out: "",
  kedah_clock_out: "",
  negeri_sembilan_clock_out: "",
  sarawak_clock_out: "",
};

function PushNotificationSettingsForm() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [valuesFromApi, setValuesFromApi] = useState(null);
  const setNotify = useNotifyContext();

  const fetchDetails = () => {
    setLoading(true);
    eightAxios
      .get(PUSHNOTIFICATION_SETTINGS_URL)
      .then((response) => {
        if (response.data.results.length > 0) {
          setValuesFromApi(
            response.data.results[response.data.results.length - 1]
          );
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleSubmit = (values) => {
    setLoading(true);
    eightAxios
      .post(PUSHNOTIFICATION_SETTINGS_URL, values)
      .then(() => {
        setNotify({
          isOpen: true,
          message: "Saved..",
          type: "success",
        });
        fetchDetails();
        setLoading(false);
      })
      .catch(() => {
        setNotify({
          isOpen: true,
          message: "Invalid Time Format",
          type: "error",
        });
        fetchDetails();
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchDetails();
  }, []);

  const formFields = [
    {
      type: "title",
      title: t("Time"),
    },
    {
      type: "renderonly",
      value: t("Kelantan"),
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "kelantan_clock_in",
      size: "small",
      gridSize: { lg: 2 },
      label: "Clock-In",
      required: true,
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "kelantan_clock_out",
      size: "small",
      label: "Clock-Out",
      gridSize: { lg: 2 },
      required: true,
    },
    {
      type: "component",
      component: FormLineBreak,
      gridSize: { lg: 6 },
    },
    {
      type: "renderonly",
      value: t("Pahang"),
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "pahang_clock_in",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "pahang_clock_out",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "component",
      component: FormLineBreak,
      gridSize: { lg: 6 },
    },
    {
      type: "renderonly",
      value: t("Perak"),
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "perak_clock_in",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "perak_clock_out",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "component",
      component: FormLineBreak,
      gridSize: { lg: 6 },
    },
    {
      type: "renderonly",
      value: t("Johor"),
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "johor_clock_in",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "johor_clock_out",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "component",
      component: FormLineBreak,
      gridSize: { lg: 6 },
    },
    {
      type: "renderonly",
      value: t("Terengganu"),
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "terengganu_clock_in",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "terengganu_clock_out",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "component",
      component: FormLineBreak,
      gridSize: { lg: 6 },
    },
    {
      type: "renderonly",
      value: t("Sabah"),
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "sabah_clock_in",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "sabah_clock_out",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "component",
      component: FormLineBreak,
      gridSize: { lg: 6 },
    },
    {
      type: "renderonly",
      value: t("Kedah"),
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "kedah_clock_in",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "kedah_clock_out",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "component",
      component: FormLineBreak,
      gridSize: { lg: 6 },
    },
    {
      type: "renderonly",
      value: t("Negeri Sembilan"),
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "negeri_sembilan_clock_in",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "negeri_sembilan_clock_out",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "component",
      component: FormLineBreak,
      gridSize: { lg: 6 },
    },
    {
      type: "renderonly",
      value: t("Sarawak"),
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "sarawak_clock_in",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "timepicker",
      variant: "outlined",
      autoComplete: "off",
      name: "sarawak_clock_out",
      size: "small",
      gridSize: { lg: 2 },
    },
    {
      type: "component",
      component: FormLineBreak,
      gridSize: { lg: 6 },
    },
    {
      type: "renderonly",
      value: t(
        "NOTE -> SUPERVISOR WILL GET PUSH NOTIFICATION ON PENDING CLOCK IN AND PENDIING CLOCK OUT WORKERS ON THE DATE AND AT THE TIME AS PER SETTINGS ABOVE"
      ),
      gridSize: { lg: 9 },
    },
    {
      type: "renderonly",
      value: t("Time Format") + ": 00:00:00 ",
      gridSize: { lg: 6 },
    },
  ];

  const formButtons = ["save"];

  if (loading) {
    return <LoadingIcon image text="Loading" />;
  }

  return (
    <Form
      initialValues={valuesFromApi ? valuesFromApi : initialValues}
      outerSubmitHandler={handleSubmit}
      listRoute="/configurations/push-notification-settings"
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Push Notification Settings"
      noListButton
    />
  );
}

export default PushNotificationSettingsForm;
